const NAV = [
  { href: '/dashboard',                label: 'Dashboard',  icon: '🏔️' },
  { href: '/vocab',                    label: 'Vocabulary', icon: '📖' },
  { href: '/grammar/building-blocks',  label: 'Grammar',    icon: '🧩' },
  { href: '/flashcards',               label: 'Flashcards', icon: '🃏' },
];

export function Sidebar() {
  return `
    <aside class="lg:w-64 lg:min-h-screen lg:sticky lg:top-0
                  lg:border-r lg:border-sand-200/70
                  bg-sand-50/90 backdrop-blur px-5 lg:px-4 py-6 z-10">
      <a href="/dashboard" data-link class="flex items-center gap-2.5 px-2 mb-8">
        <span class="inline-flex items-center justify-center w-9 h-9 rounded-xl
                     bg-moss-700 text-white font-display text-lg shadow-soft">V</span>
        <div>
          <div class="font-display font-semibold text-slate2-900 leading-none text-lg">Velkommen</div>
          <div class="text-[11px] text-slate2-500 mt-1">Learn Norwegian</div>
        </div>
      </a>

      <nav class="flex lg:flex-col gap-1 overflow-x-auto lg:overflow-visible pb-1 lg:pb-0">
        ${NAV.map(item => `
          <a href="${item.href}" data-link data-path="${item.href}"
             class="nav-link whitespace-nowrap shrink-0">
            <span class="text-base">${item.icon}</span>
            <span>${item.label}</span>
          </a>
        `).join('')}
      </nav>

      <div class="hidden lg:block mt-10 mx-2 p-4 rounded-2xl
                  bg-moss-100 border border-moss-300/40">
        <div class="text-[11px] font-semibold text-moss-800 uppercase tracking-wider">Tip</div>
        <div class="text-sm text-slate2-700 mt-1.5 leading-snug">
          Norwegian has two written forms. This app teaches <strong>Bokmål</strong> —
          the more common one, used in books, news, and most cities.
        </div>
      </div>
    </aside>
  `;
}

export function updateSidebar(activeKey) {
  document.querySelectorAll('.nav-link').forEach(el => {
    el.classList.toggle('active', el.getAttribute('data-path') === activeKey);
  });
}
